/* eslint-disable import/order */
import { RouterProvider } from '@/app/providers/RouterProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { ThemeProvider } from '@/app/providers/ThemeProviders';
import '@/app/globalStyles/styles.scss';
import '@/app/globalStyles/styles.css';
import { setConfig, setMeta, setProfile } from '@sbol/clickstream-agent';
import { getHashUserLoginId } from '@/shared/lib/clickstream-agent/utils';
import { KeycloackProvider } from './providers/KeycloackProvider';

const IS_TEST = window.location.href.includes('test');

setConfig({
    reportUrl: 'https://ext.clickstream.sberbank.ru/metrics/ecosystem/sberinsur',
});

setMeta({
    apiKey: IS_TEST
        ? '637e180f931cc8ebd2937f726c9d7c11ad8a6264d49e808a0be0f307f16eb587'
        : 'b960b139f9bd987cde8f63bf5f78c37522f4993888735076ed1dcfd9299810ce',
});

setProfile({
    hashUserLoginId: getHashUserLoginId(),
});

function App() {
    return (
        <KeycloackProvider>
            <QueryProvider>
                <ThemeProvider>
                    <RouterProvider />
                </ThemeProvider>
            </QueryProvider>
        </KeycloackProvider>
    );
}

export default App;
